// src/components/LoadingOverlay/LoadingOverlay.jsx
import styles from './LoadingOverlay.module.css';

const LoadingOverlay = ({ visible, message }) => {
  if (!visible) return null;

  return (
    <div className={styles.spinnerOverlay} role="status" aria-live="polite">
      <div className={styles.spinner} aria-hidden="true" />
      {message && (
        <div className={styles.loadingText}>{message}</div>
      )}
    </div>
  );
};

export default LoadingOverlay;
